// Components
import { Skeleton } from '@/common-utils/components/ui/skeleton';
import { Card, CardContent } from '@/common-utils/components/ui/card';
import genUID from '@/common-utils/functions/generateUniqueId';

/**
 * @returns {JSX} PieChartSkeleton
*/
function PieChartSkeleton() {
    return (
        <Card className='border border-gray-300 rounded-md min-h-[280px]'>
            <CardContent>
                <div className='flex flex-col items-start gap-2 py-2 px-2'>
                    <Skeleton className='h-6 w-24 max-w-[20%] shrink-0 rounded-md sm:max-w-[240px]' />
                    <Skeleton className='h-4 w-16 max-w-[25%] shrink-0 rounded-md sm:max-w-[240px]' />
                </div>
                <div className='flex w-full justify-center text-xs outline-none py-4 px-2'>
                    <div className='flex w-full max-w-full flex-col justify-center gap-6 pl-1 pr-12' >
                        {[1, 2, 3].map(() => (
                            <div key={genUID()} className='flex items-center gap-2'>
                                <Skeleton className='h-2 w-2 rounded-[2px]' />
                                <Skeleton className='h-3.5 w-24 rounded-md' />
                            </div>
                        ))}
                    </div>
                    <div className='flex w-full max-w-full items-center justify-center'>
                        <Skeleton className='h-[160px] w-[160px] rounded-full' />
                    </div>
                </div>
            </CardContent>
        </Card >
    );
}

export default PieChartSkeleton;
